module.exports = __webpack_public_path__ + "npr.6e7bcbfc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/logos/npr.png
// module id = 6+oj
// module chunks = 0